import script from "./EmailPreviewEnvelopeDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailPreviewEnvelopeDetails.vue?vue&type=script&setup=true&lang=js"

import "./EmailPreviewEnvelopeDetails.vue?vue&type=style&index=0&id=165d66ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165d66ec"]])

export default __exports__